import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";
import { UtilityService } from "./utility.service";
import { Program } from "../program-maintenance/program-maintenance.component";
import { ProgramDetail } from "../program-maintenance/program-detail/program-detail.component";
import { catchError } from "rxjs/operators";

@Injectable({
  providedIn: 'root'
})
export class ProgramMaintenanceService {
  constructor(private httpClient: HttpClient, private utilityService: UtilityService) {}

  public getHeaders() {
    const email = localStorage.getItem('loggedInUserEmail');
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'x-email': email,
        'x-programsponsorid': this.utilityService.currentUtility.ProgramsponsorId
      })
    };
    return httpOptions;
  }

  public mapProgram(response): Program {
    return new Program(
      response.PROGRAM_ID,
      response.SHORTNAME,
      response.DESCRIPTION,
      response.AVAILABLE,
      response.STARTDATE,
      response.ENDDATE,
      response.LONGNAME
    );
  }

  getRelatedPrograms() {
    const officeId = this.utilityService.currentUtility.OfficeId;
    const localUrl = `${environment.apiUrl}program/${officeId}/getRelatedPrograms`;

    return this.httpClient.get<Program[]>(localUrl, this.getHeaders())
      .pipe(
        catchError((err) => this.utilityService.handleError(err, this, []))
      );
  }

  getProgramDetails(programName: string) {
    const officeId = this.utilityService.currentUtility.OfficeId;
    const localUrl = `${environment.apiUrl}program/${programName}/officeId/${officeId}/getProgramDetails?code=${environment.apiCode}`;
    return this.httpClient.get<ProgramDetail[]>(localUrl, this.getHeaders())
      .pipe(
        catchError((err) => this.utilityService.handleError(err, this, []))
      );
  }

  patchProgram(editedProgram: Program) {
    const localUrl = `${environment.apiUrl}program/patchProgram`;
    return this.httpClient.patch<Program>(localUrl, editedProgram, this.getHeaders())
      .pipe(
        catchError((err) => this.utilityService.handleError(err, this, []))
      );
  }

  patchProgramDetail(editedProgramDetail: ProgramDetail) {
    const localUrl = `${environment.apiUrl}program/patchProgramDetail`;
    return this.httpClient.patch<ProgramDetail>(localUrl, editedProgramDetail, this.getHeaders())
      .pipe(
        catchError((err) => this.utilityService.handleError(err, this, []))
      );
  }
}
